import React from "react";
import ButtonForm from "../../ButtonForm/ButtonForm";
import PropTypes from "prop-types";
import "./CancelButton.css"

const CancelButton = ({
  id = "",
  title = "Cancel",
  disabled = false,
  ...rest
}) => {
  return (
    <ButtonForm
      type="button"
      id={id}
      disabled={disabled}
      value={title}
      className="btn-cancel btn-dark"
      {...rest}
    />
  );
};

CancelButton.propTypes = {
  id: PropTypes.number,
  title: PropTypes.string,
  disabled: PropTypes.bool,
};

export default CancelButton;
